import { PermissionsContextEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export function contextLabel(context: PermissionsContextEnum): string {
  switch (context) {
    case 'owned':
      return i18n.t('settings.permissions.group.contexts.owned')
    case 'reportees':
      return i18n.t('settings.permissions.group.contexts.reportees')
    case 'team_leader':
      return i18n.t('settings.permissions.group.contexts.team_leader')
    case 'legal_entity':
      return i18n.t('settings.permissions.group.contexts.legal_entity')
    case 'everybody':
      return i18n.t('settings.permissions.group.contexts.everybody')
  }
}
